module.exports = __webpack_public_path__ + "@/assets/img/layout.a0b5555c.png";